import { useActivePilotProgram } from './use-active-pilot-program';

/**
 * Partner programs that pin the advisor's organization name to a fixed value.
 * Returns the partner label to show in the "preset" tooltip, or null when the
 * org name is editable.
 */
export function useLockedOrgLabel(): string | null {
  return useActivePilotProgram()?.lockedOrgLabel ?? null;
}
